import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import { pureRender } from 'epic-alt-utils';
import { NavActions } from '../../actions';
import { getDataAttribute } from '../../utils/compatibilityUtils';

@pureRender
export default class UserIcon extends React.Component {

    @autobind
    signInonClick(e) {
        const index = getDataAttribute(e.currentTarget, 'index');
        const signInLink = this.props.signInLinks[index];
        if (signInLink && signInLink.onClick && typeof signInLink.onClick === 'function') {
            signInLink.onClick(e);
        }

        NavActions.closeMobileTablet.defer();

        setTimeout(this.showSignIn, 1);
    }

    reset() {
        //Reset all other clickable items
        NavActions.egNavActive(false);
        NavActions.tabletNavActive(false);
        NavActions.mobileLocaleActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.searchActive(false);
    }

    open() {
        if (!this.props.mobileUserActive) {
            NavActions.mobileUserActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.mobileUserActive(false);
            NavActions.mobileNavActiveLinks(true);
        }
    }

    @autobind
    showSignIn() {
        if (!this.props.signInLinks || !this.context.isMobile) {
            return;
        }

        //if there is only one sign in option just execture that onClick otherwise show a menu
        const signInLinks = this.props.signInLinks.asMutable ? this.props.signInLinks.asMutable() : this.props.signInLinks || [];
        const dropdown = signInLinks.length > 1;

        if (dropdown) {
            this.open();
            this.reset();
        }
    }

    @autobind
    showSignedIn(e) {
        e.preventDefault();

        if (!this.context.isMobile) {
            return;
        }

        this.open();
        this.reset();
    }

    render() {
        let user = <div/>;

        if (this.context.isMobile) {
            user = (
                <a>
                    <i className="eg-header-icon-user"></i>
                </a>
            );
        }

        if (this.props.isLoggedIn) {
            user = (
                <a
                    className="is-logged-in text-color-hover"
                    onClick={this.showSignedIn}>
                    {this.props.mobileUserActive ? '' : <i className="eg-header-icon-user"></i>}
                    <span className="sign-text item-label display-name text-color">{this.props.username}</span>
                </a>
            );
        } else {
            const dropdown = this.props.signInLinks && this.props.signInLinks.length > 1;
            if (dropdown) {
                user = (
                    <a href="#" className="not-logged-in text-color-hover" onClick={this.showSignedIn}>
                        {this.props.mobileUserActive ? '' : <i className="eg-header-icon-user"></i>}
                    </a>
                );
            } else if (this.context.isMobile) {
                const signInLink = this.props.signInLinks ? this.props.signInLinks[0] : null;
                if (signInLink) {
                    user = (
                        <a
                            className="not-logged-in text-color-hover"
                            href={signInLink.href || '#'}
                            data-index={0}
                            onClick={this.signInonClick}
                            title={this.context.messages.sign_in}>
                            <i className="eg-header-icon-user"></i>
                        </a>
                    );
                }
            }
        }


        return (
            user
        );
    }
}

UserIcon.propTypes = {
    isLoggedIn: React.PropTypes.bool,
    signInLinks: React.PropTypes.array,
    mobileUserActive: React.PropTypes.bool,
    username: React.PropTypes.string
};

UserIcon.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/rightNav/UserIcon.js
 **/